<template>
  <RouterView />
</template>

<style lang="scss">
#app {
  font-family: var(--va-font-family, 'Inter', sans-serif);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

body {
  margin: 0;
  min-width: 20rem;
}
</style>
